import {
  GPX_CAPABILITIES,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_ROUTES,
  gspx,
} from '@rsos/gainsight';

const LIVE_VIDEO_TC_EVENTS = Object.freeze({
  SESSION_INITIATED: 'live_video_session_initiated',
  MUTED_SELF: 'live_video_tc_muted_self',
  UNMUTED_SELF: 'live_video_tc_unmuted_self',
  MUTED_CALLER: 'live_video_tc_muted_caller',
  UNMUTED_CALLER: 'live_video_tc_unmuted_caller',
  FLIPPED_CALLER_CAMERA: 'live_video_tc_flipped_caller_camera',
  TRIGGERED_DARK_MODE: 'live_video_tc_triggered_dark_mode',
  SET_INPUT_DEVICE: 'live_video_tc_set_input_device',
  SET_OUTPUT_DEVICE: 'live_video_tc_set_output_device',
  BLURRED: 'live_video_tc_blurred',
  UNBLURRED: 'live_video_tc_unblurred',
});

const trackLiveVideoEvent = ({
  event,
  type,
  data,
}: {
  event: (typeof LIVE_VIDEO_TC_EVENTS)[keyof typeof LIVE_VIDEO_TC_EVENTS];
  type: (typeof GPX_EVENT_TYPES)[keyof typeof GPX_EVENT_TYPES];
  data: Record<string, unknown>;
}) => {
  gspx.trackEvent({
    name: event,
    type: type,
    feature: GPX_FEATURES.LIVE_VIDEO_TC,
    capability: GPX_CAPABILITIES.LIVE_VIDEO,
    route: GPX_ROUTES.EVENT_PANE,
    entities: data,
  });
};

const simpleEvent = (
  event: (typeof LIVE_VIDEO_TC_EVENTS)[keyof typeof LIVE_VIDEO_TC_EVENTS],
) => {
  return () => {
    trackLiveVideoEvent({ event, type: GPX_EVENT_TYPES.CLICK, data: {} });
  };
};

export const trackLiveVideoSessionInitiated = simpleEvent(
  LIVE_VIDEO_TC_EVENTS.SESSION_INITIATED,
);
export const trackLiveVideoTCMutedSelf = simpleEvent(
  LIVE_VIDEO_TC_EVENTS.MUTED_SELF,
);
export const trackLiveVideoTCUnmutedSelf = simpleEvent(
  LIVE_VIDEO_TC_EVENTS.UNMUTED_SELF,
);
export const trackLiveVideoTCMutedCaller = simpleEvent(
  LIVE_VIDEO_TC_EVENTS.MUTED_CALLER,
);
export const trackLiveVideoTCUnmutedCaller = simpleEvent(
  LIVE_VIDEO_TC_EVENTS.UNMUTED_CALLER,
);
export const trackLiveVideoTCTriggeredDarkMode = simpleEvent(
  LIVE_VIDEO_TC_EVENTS.TRIGGERED_DARK_MODE,
);
export const trackLiveVideoTCBlurred = simpleEvent(
  LIVE_VIDEO_TC_EVENTS.BLURRED,
);
export const trackLiveVideoTCUnblurred = simpleEvent(
  LIVE_VIDEO_TC_EVENTS.UNBLURRED,
);

export const trackLiveVideoTCSetInputDevice = (input_device?: string) => {
  trackLiveVideoEvent({
    event: LIVE_VIDEO_TC_EVENTS.SET_INPUT_DEVICE,
    type: GPX_EVENT_TYPES.CLICK,
    data: {
      input_device,
    },
  });
};

export const trackLiveVideoTCSetOutputDevice = (output_device?: string) => {
  trackLiveVideoEvent({
    event: LIVE_VIDEO_TC_EVENTS.SET_OUTPUT_DEVICE,
    type: GPX_EVENT_TYPES.CLICK,
    data: {
      output_device,
    },
  });
};

export const trackLiveVideoTCFlippedCallerCamera = (facing_mode: string) => {
  trackLiveVideoEvent({
    event: LIVE_VIDEO_TC_EVENTS.FLIPPED_CALLER_CAMERA,
    type: GPX_EVENT_TYPES.CLICK,
    data: {
      facing_mode,
    },
  });
};
